module.exports = __webpack_public_path__ + "img/xufei2025.png";